export default {
  name: "category-cards",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    cardType: {
      type: String,
      default: "category",
      validator: v => ["category"].includes(v),
    },
  },
  methods: {
    routeTo(item) {
      // Картки лишилися тільки на лендингу — бренди та колекції.
      const name = item.type === "brand" ? "brand" : "collection";
      return this.$localize({ name, params: { slug: item.slug } });
    },
  },
};
